import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'
import PdsMarker from 'components/Map/components/PdsMarker'
import { MarkerEvent } from 'components/Map/data/model'
import Search from 'components/Search'
import { SearchItemEvent, SearchItemType } from 'components/Search/Search'
import { SearchStateListItem } from 'data/model/search'
import { RootState } from 'data/reducer'
import { useAppSelector } from 'data/store/hooks'
import { mapConfig } from 'lib/config'
import { PageType, useNavigation } from 'lib/hooks'
import React, { useCallback, useState } from 'react'

interface DiscoveryPageProps {
  markersGroup: H.map.Group
}
const DiscoveryPage = ({ markersGroup }: DiscoveryPageProps): JSX.Element => {
  const { goTo } = useNavigation()

  const searchList = useAppSelector((state: RootState) => state.search.searchItemList)

  const [hoverId, setHoverId] = useState<string>()

  const handleSearchQuerySelection = useCallback(
    (value: string) => {
      if (value === '') {
        goTo({
          type: PageType.LANDING,
          url: '/',
        })
      } else {
        const encodedValue = encodeURIComponent(value)
        goTo({
          type: PageType.DISCOVERY,
          url: `/${mapConfig.url.path.discover}/${encodedValue}`,
        })
      }
    },
    [goTo]
  )

  const handleItemFocus = useCallback(
    (item: SearchItemEvent): void => {
      if (item.type === SearchItemType.Search) {
        setHoverId(item.id)
      }
    },
    [setHoverId]
  )

  const handleItemFocusOut = useCallback(
    (item: SearchItemEvent): void => {
      if (item.type === SearchItemType.Search) {
        setHoverId('')
      }
    },
    [setHoverId]
  )

  const handleMarkerCreation = useCallback(
    (marker: H.map.Marker): void => {
      markersGroup.addObject(marker)
      // Trigger the custom event that will update map's look at data
      // if (markersGroupRef.current.getObjects().length === searchList.length) {
      markersGroup.dispatchEvent(new H.util.Event(MarkerEvent.MarkersUpdate))
      // }
    },
    [markersGroup]
  )

  const handleMarkerFocus = useCallback(
    (id: string): void => {
      setHoverId(id)
    },
    [setHoverId]
  )

  const handleMarkerFocusOut = useCallback((): void => {
    setHoverId('')
  }, [setHoverId])

  const handleMarkerClick = useCallback(
    (id: string): void => {
      goTo({
        type: PageType.PDC,
        url: `/${mapConfig.url.path.pdc}/${id}`,
      })
    },
    [goTo]
  )

  return (
    <>
      <div className="Map__panel Map__panel--top Map__panel--left Map__card">
        <Search
          key="discover"
          highlightItemId={hoverId}
          onItemFocus={handleItemFocus}
          onItemFocusOut={handleItemFocusOut}
          onQuerySelect={handleSearchQuerySelection}
        />
        {searchList.map((item: SearchStateListItem, index: number) => (
          <React.Fragment key={`${item.id}-${index}`}>
            {item.position && (
              <PdsMarker
                id={item.id}
                cursor="pointer"
                isHovered={hoverId === item.id}
                categoryId={item.categoryId}
                lat={item.position.lat}
                lng={item.position.lng}
                zIndex={hoverId === item.id ? searchList.length + 1 : searchList.length - index}
                onMarkerCreate={handleMarkerCreation}
                onMouseEnter={handleMarkerFocus}
                onMouseLeave={handleMarkerFocusOut}
                onClick={handleMarkerClick}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  )
}

export default DiscoveryPage
